import styled from 'styled-components'
import IconButton from 'ui/src/components/controls/icon-button'
import ArtboardComponent from './board'

export const Artboard = styled(ArtboardComponent)`
    border-radius: inherit;
    margin: 0 auto;
`

export const Container = styled.div`
    border-radius: inherit;
    position: relative;
`

export const PlayPause = styled(IconButton)<{ hidden: boolean }>`
    bottom: 8px;
    left: 8px;
    opacity: ${({ hidden }) => (hidden ? 0 : 1)};
    position: absolute;
    transition: opacity 0.15s ease-out;

    &:active {
        opacity: 0.8;
    }
`

export const LoaderWrapper = styled.div`
    align-items: center;
    display: flex;
    justify-content: center;
`

export const Wrapper = styled.div`
    background-color: #000;
    background-image:
        linear-gradient(45deg, #0e0e0e 25%, transparent 25%, transparent 75%, #0e0e0e 75%),
        linear-gradient(45deg, #0e0e0e 25%, transparent 25%, transparent 75%, #0e0e0e 75%);
    background-size: 24px 24px;
    background-position:
        0 0,
        12px 12px;
    border-radius: inherit;
    position: relative;
    margin: 0 auto;
`
